// Formats a decimal to a currency string based on currencySymbol passed
export const toCurrency = (
  number,
  currencySymbol = '$',
  currencySymbolFirst = true
) => {
  if (number === 0) return `${currencySymbol}0`;

  // Right-sided currency case
  const rightCurrencies = ['kn', 'kr', 'kr.'];
  if (rightCurrencies.includes(currencySymbol)) {
    return `${parseFloat(number).toFixed(2)} ${currencySymbol}`;
  }

  if (currencySymbolFirst === false) {
    return `${parseFloat(number).toFixed(2)} ${currencySymbol}`;
  }

  return `${currencySymbol}${parseFloat(number).toFixed(2)}`;
};

// Converst a formatted currency string to a decimal/float
export const toNumber = (currency) => {
  let number = currency.replace(/[^0-9.-]+/g, '');

  // Special case for Krone (kr.)
  if (number.toString().slice(-1) === '.') {
    number = number.toString().slice(0, -1);
  }

  // Special case for Peruvian Sol (S/.)
  if (number.toString().charAt(0) === '.') {
    number = number.toString().substr(1);
  }

  return Number(number);
};
